export function getRatingAverage(dataSet, nurseryId) : any {
  const matchingIds = dataSet.filter((rating) => {
    return rating.nursery_id === nurseryId;
  });
  let average = matchingIds.reduce((sum, value) => {
    return sum + value.score;
  }, 0) / matchingIds.length;
  if (average % 1 == 0) return average.toFixed(1); // no decimal, return one...
  return average || 0;
}